import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import { ElementWithTooltip } from 'DesignSystem/Tooltips';
import { ProductContent } from 'DesignSystem/Typography';

const RecipientPreviewToggleButtonWithTooltip = ({
  activeTooltipIndex,
  children: recipientPreviewToggleButton,
  isTourDisplayed,
}) => {
  const isPreviewButtonTooltipDisplayed = isTourDisplayed &&
  (activeTooltipIndex === SelfServeTooltipTourConstants.PREVIEW_BUTTON_TOOLTIP_IDX);

  if (isPreviewButtonTooltipDisplayed) {
    return (
      <ElementWithTooltip
        className="recipient-preview-tour-tooltip recipient-preview-button-tooltip"
        displayEvent="none"
        placement="bottom"
        showByDefault
        showCloseButton
        targetClassName="recipient-preview-toggle-button"
        targetElement={recipientPreviewToggleButton}
        tooltipId="selfServeRecipientPreviewButtonTooltip"
      >
        <div className="recipient-preview-tour-tooltip-content">
          <ProductContent
            className="recipent-preview-button-tooltip-text bold"
            variation="small"
          >
            Find the recipient preview again here.
          </ProductContent>
          <ProductContent
            className="recipent-preview-button-tooltip-text"
            variation="small"
          >
            Test how your recipient&#39;s answers will automatically plug into your document.
          </ProductContent>
        </div>
      </ElementWithTooltip>
    );
  }

  return recipientPreviewToggleButton;
};

RecipientPreviewToggleButtonWithTooltip.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  isTourDisplayed: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
});

export default ReactRedux.connect(
  mapStateToProps,
)(RecipientPreviewToggleButtonWithTooltip);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/RecipientPreviewToggleButtonWithTooltip.jsx